<template>
  <el-drawer
    title="点位事项指标"
    :visible.sync="dialogVisible"
    width="1020px"
    :before-close="handleClose"
    :modal="true"
    direction="rtl"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <common-table
        :select="false"
        :dataList="dataList"
        :isShowPagination="false"
      >
        <template v-slot:relState="{ scope }">
          <el-switch
            @change="
              value => {
                relChangeStateFun(value, scope.row);
              }
            "
            v-model="scope.row.relState"
            active-value="是"
            inactive-value="否"
            active-color="#0495FF"
          >
          </el-switch>
        </template>
      </common-table>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="fillTaskItemFun">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span> -->
  </el-drawer>
</template>
<script>
import {
  relList,
  relChangeState,
  relListByEventMangerId,
  batchChangeState
} from "@/api/point.js";
import commonTable from "@/components/table/index.vue";
export default {
  components: {
    commonTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    eventMangerId: {
      type: String,
      default: ""
    },
    ghPointLevelIdList: {
      type: Array,
      default: []
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "zbmc",
            label: "指标名称"
          },
          {
            prop: "khdx",
            label: "考核对象（指标类型）"
          },
          {
            slot: "relState",
            label: "应用状态"
          }
        ]
      }
    };
  },
  mounted() {
    if (this.type == 1) this.relListFun();
    if (this.type == 2) this.relListByEventMangerIdFun();
  },
  methods: {
    async relListByEventMangerIdFun() {
      const res = await relListByEventMangerId({
        eventMangerId: this.eventMangerId
      });
      this.dataList.tableData = res.data.data;
    },
    async relListFun() {
      const res = await relList({
        eventMangerId: this.curItem.eventMangerId,
        pointLevelId: this.curItem.pointLevelId
      });
      this.dataList.tableData = res.data.data;
    },
    async relChangeStateFun(value, item) {
      let res = null;
      if (this.type == 1) {
        res = await relChangeState({
          relId: item.id,
          relState: value
        });
      } else if (this.type == 2) {
        let arr = [];
        this.dataList.tableData.forEach(element => {
          arr.push({
            ghEventIndexId: element.eventIndexId,
            relState: element.relState
          });
        });
        res = await batchChangeState({
          changes: arr,
          ghPointLevelIdList: this.ghPointLevelIdList
        });
      }

      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    handleClose() {
      this.$emit("update:dialogVisible", false);
    },
   // fillTaskItemFun() {}
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-drawer {
  width: 779px !important;

  background: #ffffff;
  box-shadow: 0px 1px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 4px 0px 0px 4px;
}
/deep/.el-drawer__header {
  font-family: MiSans, MiSans;
  font-weight: 700;
  font-size: 20px;
  color: #494c4f;
  span {
    color: #494c4f;
  }
}
.container-dialog {
  padding: 0 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointEvent/components/sxzbDrawer.vue